import { products } from "../endpoints/products.endpoints";
import $axios from "../http/accessor";

const ProductsService = {
  getAllProducts: (page: number, count: number, currency_id: number) => {
    return $axios.get(products.all_products, {
      params: {
        page,
        count,
        currency_id,
      },
    });
  },

  getSingleProduct: (id: number, currency_id?: number) => {
    return $axios.get(products.single_product(id), {
      params: currency_id ? { currency_id } : {},
    });
  },

  getCategories: () => {
    return $axios.get(products.get_categories);
  },

  getCategoriesAttribute: (id: number, page?: number, count?: number) => {
    return $axios.get(products.get_categories_attribute, {
      params: {
        id,
        page,
        count,
      },
    });
  },

  getBrands: (page?: number, count?: number) => {
    return $axios.get(products.get_brands, {
      params: {
        page,
        count,
      },
    });
  },

  getCurrency: () => {
    return $axios.get(products.get_currency);
  },

  getALLStores: (page: number, count: number, search?: string) => {
    return $axios.get(products.get_all_stores, {
      params: {
        page,
        count,
        search,
      },
    });
  },

  getALLStoresWithProducts: (
    currency_id: number,
    page: number,
    count: number,
  ) => {
    return $axios.get(products.get_all_stores_products, {
      params: {
        currency_id,
        page,
        count,
      },
    });
  },

  getProductsStore: (
    id: number,
    page: number,
    count: number,
    search?: string,
  ) => {
    return $axios.get(products.get_products_in_store(id), {
      params: {
        page,
        count,
        search,
      },
    });
  },

  getAllBAsket: (currency_id: number) => {
    return $axios.get(products.get_all_basket(currency_id));
  },

  getBasketDelivery: (currency_id: number) => {
    return $axios.get(products.get_basket_delivery(currency_id));
  },

  getDeliverySettings: (currency_id: number) => {
    return $axios.get(products.get_delivery_settings(currency_id));
  },

  getInstallmentBanks: () => {
    return $axios.get(products.get_installment_banks);
  },

  updateBasket: (_currency_id: number, formData: FormData) => {
    return $axios.put(products.update_basket, formData);
  },

  updateBasketAuth: (currency_id: number, formData: FormData) => {
    return $axios.put(products.update_basket_auth(currency_id), formData);
  },

  removeBasket: () => (formData: FormData) => {
    return $axios.post(products.remove_basket, formData);
  },

  clearBasket: () => () => {
    return $axios.delete(products.clear_basket);
  },

  getAllWishlist: (currency_id: number) => {
    return $axios.get(products.get_all_wishlist(currency_id));
  },

  removeAddWishlist: (formData: FormData) => {
    return $axios.post(products.remove_add_wishlist, formData);
  },

  filterProducts: (
    category_id: number,
    currency_id?: number,
    params?: URLSearchParams,
  ) => {
    const requestParams: Record<string, string | number> = {};

    if (typeof currency_id === "number") {
      requestParams.currency_id = currency_id;
    }

    if (params) {
      params.forEach((value, key) => {
        requestParams[key] = value;
      });
    }

    return $axios.get(products.filter(category_id), {
      params: requestParams,
    });
  },

  searchProducts: (
    query: string,
    currency_id?: number,
    lang?: string,
    page?: number,
    size?: number,
    category_id?: number,
    min_price?: number,
    max_price?: number,
  ) => {
    const params: Record<string, string | number> = {
      q: query,
    };

    if (currency_id) {
      params.currency_id = currency_id;
    }

    if (lang) {
      params.lang = lang;
    }

    if (page) {
      params.page = page;
    }

    if (size) {
      params.size = size;
    }

    if (category_id) {
      params.category_id = category_id;
    }

    if (min_price) {
      params.min_price = min_price;
    }

    if (max_price) {
      params.max_price = max_price;
    }

    return $axios.get(products.search, { params });
  },

  completeOrderAndPay: (formData: FormData) => {
    return $axios.post(products.complete_order, formData);
  },

  createWidgetPayment: (formData: FormData) => {
    return $axios.post(products.complete_order_widget, formData);
  },

  getAllOrders: (page: number, count: number) => {
    return $axios.get(products.my_orders, {
      params: {
        page,
        count,
      },
    });
  },
};

export default ProductsService;
